import ApiService from "../utils/ApiService";

export const printerSettingsDefaultData = {
  isAutoPrint: false,
  connectionType: "",
  printerType: "",
  tcpConnectionInfo: {
    ip: "",
    port: "9100",
  },
  cashDrawerCommand: '1B70004050'
};

export const printerSettingsInitData = {
  isServerDataLoaded: false,
  printerSettingsInvoice: {
    isAutoPrint: false,
    connectionType: "TCP",
    printerType: "80",
    tcpConnectionInfo: {
      ip: "",
      port: "9100",
    },
    bluetoothPort: "",
    usbDeviceName: "",
    printerName: "",
    cashDrawerCommand: "1B70004050",
  },
  printerSettingsKitchenSlip: {
    isAutoPrint: false,
    connectionType: "TCP",
    printerType: "80",
    tcpConnectionInfo: {
      ip: "",
      port: "9100",
    },
    bluetoothPort: "",
    usbDeviceName: "",
    printerName: "",
    cashDrawerCommand: "",
  },
};

export const validateTestPrintData = (printerSettings, receivePrinterObj) => {
  if (printerSettings.connectionType === "USB" && receivePrinterObj.printerList.length === 0) {
    return "No USB connected printer found.";
  }

  if (printerSettings.connectionType === "USB" && printerSettings.usbDeviceName === "") {
    return "No printer selected.";
  }

  return "";
};
export const validatePrinterSettingsInputs = (inputs) => {
  if (!inputs.printerName) {
    return "Please select a printer from printer list.";
  }

  if (!inputs.printerType) {
    return "Please select printer type.";
  }

  return "";
};

export const scanBluetoothDevicesReq = async (params, token) => {
  try {
    const reqBody = {
      ...params,
    };

    const res = await ApiService.SEND_BLUETOOTH_DEVICE_SCAN_REQ(reqBody, token);

    console.log("res---", res);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Sent bluetooth device scan request successfully." : res.message,
    };
  } catch (error) {
    return {
      success: false,
      msg: "Faild to send bluetooth devices scan request. Please, try again.",
    };
  }
};
/**
 * update printer settings
 *
 * @param {*} params
 * @param {*} token
 */
export const updatePrinterSettings = async (params, token) => {
  try {
    const reqBody = {
      ...params,
      isAutoPrint: params.isAutoPrint ? "YES" : "NO",
    };

    const res = await ApiService.UPDATE_PRINTER_SETTINGS(reqBody, token);

    console.log("res---", res);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Data updated successfully." : res.message,
    };
  } catch (error) {
    return {
      success: false,
      msg: "Faild to update data. Please try again.",
    };
  }
};

const getPrinterSettingsFormatedData = (settingsItem) => {
  if (!settingsItem) {
    return printerSettingsDefaultData;
  }

  return {...settingsItem, cashDrawerCommand: settingsItem.cashDrawerCommand || '1B70004050'};
};
/**
 * update printer settings
 *
 * @param {*} params
 * @param {*} token
 */
export const getPrinterSettings = async (params, token) => {
  try {
    const res = await ApiService.GET_PRINTER_SETTINGS_DATA(params, token);

    let { printerSettingsInvoice, printerSettingsKitchenSlip, cashDrawerCommands } = res.payload;

    printerSettingsInvoice = getPrinterSettingsFormatedData(printerSettingsInvoice);
    printerSettingsKitchenSlip = getPrinterSettingsFormatedData(printerSettingsKitchenSlip);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Success" : res.message,
      data: { printerSettingsInvoice, printerSettingsKitchenSlip, cashDrawerCommands },
    };
  } catch (error) {
    return {
      success: false,
      msg: "Faild to update data. Please try again.",
    };
  }
};

/**
 * update printer settings
 *
 * @param {*} params
 * @param {*} token
 */
export const sendPrinterConnectionTestRequest = async (params, token) => {
  try {
    const res = await ApiService.SEND_PRINT_TEST_REQUEST(params, token);

    console.log("res---", res);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Printer connection test request sent." : res.message,
    };
  } catch (error) {
    console.error("Faild to send printer connection test request. Error:", error);
    return {
      success: false,
      msg: "Faild to send printer connection test request",
    };
  }
};
